var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 73.673,
    y: 7.95,
    style: {
      fill: "#5CC4E0"
    },
    width: 364.654,
    height: 496.099
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.354,
    y: 67.313,
    style: {
      fill: "#FFFFFF"
    },
    width: 305.292,
    height: 394.335
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF675C"
    },
    d: "M323.843,96.994H188.157V41.872h41.373c6.212-7.749,15.763-12.72,26.469-12.72 s20.257,4.972,26.469,12.72h41.373V96.994z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DB3D5A"
    },
    points: "205.118,80.033 205.118,50.352 205.118,41.872 188.157,41.872 188.157,67.313  188.157,96.994 323.843,96.994 323.843,80.033 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M188.157,232.149h-46.642c-4.391,0-7.95-3.56-7.95-7.95v-46.642c0-4.391,3.56-7.95,7.95-7.95h46.642 c4.391,0,7.95,3.56,7.95,7.95v46.642C196.108,228.589,192.548,232.149,188.157,232.149z M149.466,216.248h30.741v-30.741h-30.741 V216.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M188.157,321.193h-46.642c-4.391,0-7.95-3.56-7.95-7.95V266.6c0-4.391,3.56-7.95,7.95-7.95h46.642 c4.391,0,7.95,3.56,7.95,7.95v46.642C196.108,317.633,192.548,321.193,188.157,321.193z M149.466,305.292h30.741v-30.741h-30.741 V305.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M188.157,410.236h-46.642c-4.391,0-7.95-3.56-7.95-7.95v-46.642c0-4.391,3.56-7.95,7.95-7.95h46.642 c4.391,0,7.95,3.56,7.95,7.95v46.642C196.108,406.676,192.548,410.236,188.157,410.236z M149.466,394.335h30.741v-30.741h-30.741 V394.335z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5293C4"
    },
    d: "M158.48,210.948c-2.248,0-4.475-0.951-6.04-2.777l-25.441-29.681 c-2.858-3.334-2.472-8.352,0.862-11.21c3.333-2.858,8.352-2.471,11.21,0.862l20.664,24.109l87.347-63.525 c3.552-2.583,8.525-1.797,11.106,1.753c2.583,3.551,1.798,8.524-1.753,11.106l-93.284,67.843 C161.745,210.451,160.108,210.948,158.48,210.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5293C4"
    },
    d: "M158.48,299.992c-2.248,0-4.475-0.951-6.04-2.777l-25.441-29.681 c-2.858-3.334-2.472-8.352,0.862-11.21c3.333-2.858,8.352-2.471,11.21,0.862l20.664,24.109l87.347-63.525 c3.552-2.583,8.525-1.797,11.106,1.753c2.583,3.551,1.798,8.524-1.753,11.106l-93.284,67.843 C161.745,299.495,160.108,299.992,158.48,299.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5293C4"
    },
    d: "M158.48,389.035c-2.248,0-4.475-0.951-6.04-2.777l-25.441-29.681 c-2.858-3.334-2.472-8.352,0.862-11.21c3.333-2.858,8.352-2.471,11.21,0.862l20.664,24.109l87.347-63.525 c3.552-2.583,8.525-1.797,11.106,1.753c2.583,3.551,1.798,8.524-1.753,11.106l-93.284,67.843 C161.745,388.538,160.108,389.035,158.48,389.035z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.327,0h-43.991c-4.391,0-7.95,3.56-7.95,7.95s3.56,7.95,7.95,7.95h36.04v480.199H155.296c-4.391,0-7.95,3.56-7.95,7.95 c0,4.391,3.56,7.95,7.95,7.95h283.031c4.391,0,7.95-3.56,7.95-7.95V7.95C446.277,3.56,442.718,0,438.327,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.678,496.099H81.623V15.901h274.021c4.391,0,7.95-3.56,7.95-7.95S360.035,0,355.644,0H73.673 c-4.391,0-7.95,3.56-7.95,7.95V504.05c0,4.391,3.56,7.95,7.95,7.95h44.006c4.391,0,7.95-3.56,7.95-7.95 C125.629,499.659,122.069,496.099,117.678,496.099z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.681,195.048c-4.391,0-7.95,3.56-7.95,7.95c0,4.391,3.56,7.95,7.95,7.95h84.803c4.391,0,7.95-3.56,7.95-7.95 c0-4.391-3.56-7.95-7.95-7.95H285.681z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M370.484,284.091h-84.803c-4.391,0-7.95,3.56-7.95,7.95s3.56,7.95,7.95,7.95h84.803c4.391,0,7.95-3.56,7.95-7.95 S374.875,284.091,370.484,284.091z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M370.484,373.135h-83.743c-4.391,0-7.95,3.56-7.95,7.95s3.56,7.95,7.95,7.95h83.743c4.391,0,7.95-3.56,7.95-7.95 S374.875,373.135,370.484,373.135z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M323.843,33.921h-37.794c-7.864-8.128-18.613-12.72-30.049-12.72s-22.185,4.592-30.049,12.72h-37.794 c-4.391,0-7.95,3.56-7.95,7.95v17.491h-76.853c-4.391,0-7.95,3.56-7.95,7.95v394.335c0,4.391,3.56,7.95,7.95,7.95h305.292 c4.391,0,7.95-3.56,7.95-7.95V67.313c0-4.391-3.56-7.95-7.95-7.95h-76.853V41.872C331.793,37.481,328.233,33.921,323.843,33.921z  M196.108,49.822h33.423c2.413,0,4.694-1.095,6.203-2.978c4.963-6.192,12.351-9.743,20.266-9.743c7.915,0,15.303,3.551,20.267,9.743 c1.508,1.882,3.791,2.978,6.203,2.978h33.422v17.491v21.731H196.108V67.313V49.822z M400.696,453.698H111.304V75.263h68.903v21.731 c0,4.391,3.56,7.95,7.95,7.95h135.685c4.391,0,7.95-3.56,7.95-7.95V75.263h68.903V453.698z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListClipboard);
export default __webpack_public_path__ + "static/media/list-clipboard.43a1c9695844b25758fad96ff1dc7149.svg";
export { ForwardRef as ReactComponent };